import type { Prototype } from "../prototype-types";

export const ajaybirRatoulPrototypes: Prototype[] = [
  {
    id: "ajr-onboarding-products-slider",
    name: "Onboarding Products Slider",
    path: "/ajr/onboarding-products-slider",
    description:
      "Slider prototype for the brand onboarding products-count step, replacing the range picker to preserve granularity for Featured eligibility",
    owner: "Ajaybir Ratoul",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-14",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/278c3d8e8e272080fc9a4579da7f132e655f040ba1bbdbd485d5cd4c26429a31.png",
    creationTool: "claude-code",
  },
];
